<div class="modal-wrapper premium-promo-modal" role="dialog" aria-modal="true" cdkTrapFocus="true" *transloco="let t;">

  <div class="modal-body">
    @if (isSinglePlan()) {
      <div class="header-wrapper">
        <div class="title-wrapper">
          <h1 id="premium-promo-title" class="title">
            {{ t('modals.premium_promo.title') }}
          </h1>

          <p id="premium-promo-subtitle" class="subtitle" [innerHTML]="savingsHeadline()">
          </p>
        </div>

        <button type="button" class="button-undecorated" (click)="closeModal()"
          [attr.aria-label]="t('modals.premium_promo.ariaLabelClose')">
          <cwo-round-icon [iconName]="iconNameType.close" [size]="'medium'" aria-hidden="true" />
        </button>
      </div>
    }

    @if(isSinglePlan()) {
      <cwo-plan-premium-single [plan]="subscriptions()[0]"/>
    }
    @else {
      <cwo-plan-premium-multi
        [plans]="subscriptions()"
        [selectedName]="selectedSubscription()?.subscriptionName ?? null"
        (planSelected)="selectSubscription($event)"
        [savingsHeadline]="savingsHeadline()"
      />
    }

    <hr class="divider" aria-hidden="true" />

    <p class="footer-text" id="premium-promo-footer" [innerHTML]="upgradeSummary()"></p>
  </div>

  <div class="modal-footer">
    <a class="cta" [routerLink]="storeIdService.getRoutePathSegments(['subscription-payment'])" (click)="closeModal()">{{ ctaLabel() }}</a>
  </div>

</div>